export enum EnRptType {
    WordTemplate = 'wordtemplate',
    ReportView = 'reportview',
    Custom = 'custom',
    ExternalUrl = 'externalurl',
    InternalUrl = 'internalurl'
}